<ph-dialog open size="lg" heading="View invoice" (ph-close)="closeDialog()">
    <ph-facts value-align="end" label-width="100px">
        <ph-fact>
            <ph-label>Vendor</ph-label>
            <div>{{ vendorName }}</div>
        </ph-fact>
        <ph-fact>
            <ph-label>Invoice #</ph-label>
            <div>{{ invoiceNumber }}</div>
        </ph-fact>
    </ph-facts>

    <div class="invoice-viewer-container" *ngIf="invoiceAttachment; else noInvNum">
        <app-payable-attachment-carousel
            [attachments]="[invoiceAttachment]"
            [showCaptions]="false"
            [emptyMessage]="'No invoice attached'">
        </app-payable-attachment-carousel>
    </div>

    <ng-template #noInvNum>
        <ph-empty-state icon="file-text" heading="No invoice attached">
            This payable has no invoice attached.
        </ph-empty-state>
    </ng-template>

    <ph-actions slot="footer">
        <ph-button variant="secondary" mode="filled" (click)="closeDialog()">Close</ph-button>
        <ph-button [disabled]="isSubmitting" (click)="downloadInvoice()">Download invoice</ph-button>
    </ph-actions>
</ph-dialog>
